import React from "react";
import styled from "styled-components";
import { ExclamationCircle } from "@vitalsource/vstui-icons";
import { cloud, red } from "@vitalsource/vstui/colors";
import { useIntl } from "react-intl";

const Styled = {
  Page: styled.div<{ contained?: boolean }>`
    height: 100%;
    width: 100%;
    padding: 1em;
    display: flex;
    justify-content: center;
    overflow: auto;
  `,
  ErrorContainer: styled.div`
    margin: 2rem 0 3rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-self: center;
  `,
  Main: styled.div`
    color: ${cloud.getShade(9)};
    font-size: 2.4rem;
    font-weight: 700;
    line-height: 3rem;
    text-align: center;
    margin: 2rem 0;
  `,
  Sub: styled.div`
    color: ${cloud.getShade(9)};
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 2rem;
    max-width: 366px;
    text-align: center;
  `,
  IconContainer: styled.div`
    svg {
      fill: ${red.getShade(6)};
      height: 3rem;
      width: 3rem;
    }
  `,
};

const Errors = ({
  icon,
  main,
  sub,
}: {
  icon?: any;
  main?: string;
  sub?: string;
}) => {
  const intl = useIntl();
  return (
    <Styled.Page>
      <Styled.ErrorContainer>
        <Styled.IconContainer>
          {icon || <ExclamationCircle />}
        </Styled.IconContainer>
        <Styled.Main>
          {main ||
            intl.formatMessage({
              id: "errors.generalMain",
              // Default message in case locale load error
              defaultMessage: "Something Went Wrong",
            })}
        </Styled.Main>
        <Styled.Sub>
          {sub ||
            intl.formatMessage({
              id: "errors.generalSub",
              // Default message in case locale load error
              defaultMessage: "Reload your browser or try again later",
            })}
        </Styled.Sub>
      </Styled.ErrorContainer>
    </Styled.Page>
  );
};

export default Errors;
